import { QueryObserverOptions, useQuery } from 'react-query';

import { useDlVaultContract } from 'clients/contracts';
import { DEFAULT_REFETCH_INTERVAL_MS } from 'constants/defaultRefetchInterval';
import getTimeConfig, { GetTimeConfigInput, GetTimeConfigOutput } from '.';

type TrimmedGetTimeConfigInput = Omit<GetTimeConfigInput, 'dlVaultContract'>;

export type UseGetTimeConfigQueryKey = [
  'getTimeConfig',
  TrimmedGetTimeConfigInput,
];

type Options = QueryObserverOptions<
  GetTimeConfigOutput,
  Error,
  GetTimeConfigOutput,
  GetTimeConfigOutput,
  UseGetTimeConfigQueryKey
>;

const useGetTimeConfig = (input: TrimmedGetTimeConfigInput = {}, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    ['getTimeConfig', input],
    () => getTimeConfig({ dlVaultContract, ...input }),
    {
      refetchInterval: DEFAULT_REFETCH_INTERVAL_MS,
      ...options,
    },
  );
};

export default useGetTimeConfig; 